import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../../shared/locales/no.json';
import HomePageLinkView from './HomePageLinkView';
import withEditableWrapper from '../../../components/form/EditableWrapper';
import CancelableTextInput from '../../../components/form/CancelableTextInput.jsx';

const Wrapper = withEditableWrapper(CancelableTextInput, HomePageLinkView);

export default class EditableHomePageLink extends PureComponent {
    static propTypes = {
        text: PropTypes.string,
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        onUpdate: PropTypes.func.isRequired,
    };

    render() {
        return (
            <Wrapper
                label="Bedriftens hjemmeside"
                placeholder="http://www.din-adresse.no"
                type="url"
                validationErrorMsg={i18n['Invalid url']}
                validations="isUrl"
                {...this.props}
            />
        );
    }
}
